<template lang="pug">
.card(v-on="$listeners")
  .card-name(v-text="occupation.company_name")
  .u-pts.u-color-gray
    span(v-text="employmentStatus")
    span ・
    span(v-text="formatDate(occupation.working_started_at)")
    span  -
    span(v-if="occupation.working_ended_at != null", v-text="formatDate(occupation.working_ended_at)")
  .u-ptm(v-text="occupation.remarks")
</template>

<script>
import {defineComponent} from "vue";
import EMPLOYMENT_STATUSES from "@/constants/employmentStatuses";
import dayjs from "dayjs";

export default defineComponent({
  name: "WorkHistoryCard",
  props: {
    occupation: {
      type: Object,
      required: true
    }
  },
  setup({ occupation: { employment_status } }) {
    const employmentStatus = EMPLOYMENT_STATUSES.find((status) => status.value === employment_status).name;
    const formatDate = (date) => dayjs(date).format('YYYY年MM月DD日')

    return { employmentStatus, formatDate }
  }
})
</script>

<style scoped lang="scss">
.card {
  padding: 15px;
  border: 1px solid #E5E5E5;
  box-sizing: border-box;
  border-radius: 3px;

  &-name {
    color: #1D1918;

    font-weight: bold;
    font-size: 16px;
    line-height: 16px;
  }
}
</style>
